import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserRest } from 'src/app/models/auth/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { IChildItem, IMenuItem } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-head-nav',
  templateUrl: './head-nav.component.html'
})
export class HeadNavComponent implements OnInit {
  @Input() customClass!: string;
  @Input() hasRestaurant = true; // add restaurant to breadcrumb, restaurantId must has value
  @Input() hasBranshes = true; // own restaurant dropdown
  @Input() hideBranshes = false; // own restaurant dropdown
  @Input() childViewTitle = '';

  @Input() restaurantId?: any;
  @Input() changeRestaurantLoading = false;
  restaurantData?: any;

  @Input() queryParams: any = {};

  @Output() selectedRestaurantId = new EventEmitter();
  @Output() ownRests = new EventEmitter<UserRest[]>();
  @Output() isChanged = new EventEmitter<boolean>();

  /*******************************/
  @Input() isRestProfile = false;

  @Input() isParentLink = false; // to make parent likable (like. lists and details)
  @Input() currentView?: string;

  menuItems?: IMenuItem[];
  navBreadcrumb: (IMenuItem | IChildItem)[] = [];

  constructor(
    public authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.authenticationService.menuLoaded.subscribe(items => {
      this.menuItems = items;
      this.getActiveMenuParent();
    });
    this.activatedRoute.params.subscribe(params => {
      this.getActiveMenuParent();
    });
  }

  ngOnInit(): void {
    this.setRestaurantName();
    this.queryParams = { ...{ id: this.restaurantId }, ...this.queryParams };
    this.cdr.detectChanges();
  }

  getActiveMenuParent() {
    this.navBreadcrumb = [];
    if (!this.menuItems?.length) return;
    let activelink: any;
    this.menuItems.forEach(i => {
      if (!activelink) {
        if (i.sub?.length) {
          activelink = i.sub?.find(s => location.href.includes(s.state));
          if (activelink) {
            this.navBreadcrumb.push(i);
          }
        } else if (location.href.includes(i.state)) {
          activelink = i;
        }
      }
    });
    if (activelink) {
      this.navBreadcrumb.push(activelink);
    }
  }

  branchChanged(id: any) {
    this.restaurantId = id;
    this.setRestaurantName();
    this.selectedRestaurantId.emit(id);
  }

  setRestaurantName() {
    let restId = localStorage.getItem('restaurantId');
    this.restaurantId = restId;
    let restName = this.authenticationService.currentUserValue?.owneRestaurant.find(r => r.id == Number(restId))?.name || '';
    this.restaurantData = { name: restName };
    this.cdr.detectChanges();
  }
}
